<template>
  <button class="cta-button" @click="handleClick">
    <div class="button-content">
      <div class="button-title">{{ displayTitle }}</div>
      <div v-if="displaySubtitle" class="button-subtitle">{{ displaySubtitle }}</div>
    </div>
  </button>
</template>

<script setup>
import { computed } from 'vue'
import { useLanguage } from '@/composables/useLanguage'

const { t } = useLanguage()

const props = defineProps({
  title: {
    type: String,
    default: null
  },
  subtitle: {
    type: String,
    default: null
  },
  url: {
    type: String,
    default: ''
  }
})

const displayTitle = computed(() => props.title || t('cta_button.default_title'))
const displaySubtitle = computed(() => props.subtitle || t('cta_button.default_subtitle'))

const emit = defineEmits(['click'])

const handleClick = () => {
  window.open('https://monglish.zohobookings.com/#/4757440000000046052', '_blank');

  if (props.url && props.url !== '#') {
    window.location.href = props.url
  }
}
</script>

<style scoped>
.cta-button {
  padding: clamp(18px, 2.5vw, 28px) clamp(30px, 4vw, 50px);
  width: 100%;
  min-width: 200px;
  max-width: 800px;
  background: linear-gradient(90deg, #ff8f37 0%, #ff7a2d 100%);
  border: none;
  border-radius: clamp(12px, 2vw, 16px);
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0px 6px 20px rgba(255, 143, 55, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(4px, 0.5vw, 8px);
}

.button-title {
  font-size: clamp(16px, 2vw, 22px);
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.5px;
  line-height: 1.2;
  text-align: center;
  text-transform: uppercase;
  font-family: inherit;
}

.button-subtitle {
  font-size: clamp(12px, 1.3vw, 14px);
  font-weight: 400;
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.4;
  text-align: center;
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0px 8px 24px rgba(255, 143, 55, 0.45);
  background: linear-gradient(90deg, #ff7a2d 0%, #ff8f37 100%);
}

.cta-button:active {
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .cta-button {
    min-width: 180px;
  }
}

@media (max-width: 480px) {
  .cta-button {
    min-width: 160px;
    width: 100%;
    max-width: 300px;
  }
}
</style>
